import { render } from "./autograph.vue?vue&type=template&id=59e7790d"
import script from "./autograph.vue?vue&type=script&lang=js"
export * from "./autograph.vue?vue&type=script&lang=js"

import "./autograph.vue?vue&type=style&index=0&id=59e7790d&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanrenrenxing\\guifanrenrenxing-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__